module.exports = __webpack_public_path__ + "media/images/past_order_history/btn_Category_2_01-6b0d9e3c7ba15f4d520b8ccb4182e846.png";